import _ from 'underscore'
import React, { useState } from 'react'

import EditableComponent from 'pages/Device/SystemComponentsPanel/EditableComponent'
import DisplayComponent from 'pages/Device/SystemComponentsPanel/DisplayComponent'

import Api from 'services/api'
import Apptentive from 'helpers/apptentive'

import { SystemComponent } from 'types/SystemComponent'

export type Props ={
  component: Required<SystemComponent>
  deviceId: string
  onCancelCallBack: (arg: Required<SystemComponent>) => void
  onRefreshCallBack: () => void
  setEditCallBack: (arg?:Required<SystemComponent>) => void
  editableComponent: Required<SystemComponent>
  disabled: boolean
}

const Component = ({ disabled, editableComponent, component, deviceId, onCancelCallBack, onRefreshCallBack, setEditCallBack: setEditCallback }: Props) => {
  const [newComponent, setNewComponent] = useState<SystemComponent>(component)
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setIsLoading] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const onSave = () => {
    setIsLoading(true)
    setShowSpinner(true)
    if (newComponent.modelNumber.length) {
      if (newComponent.id) {
        Api.SystemComponents.update(deviceId, newComponent.id, newComponent).then(() => {
          onRefreshCallBack()
          setIsLoading(false)
          setShowSpinner(false)
        })
      } else {
        Api.SystemComponents.create(deviceId, newComponent).then(() => {
          Apptentive.sendEvent('add_system_component_saved')

          onRefreshCallBack()
          setIsLoading(false)
          setShowSpinner(false)
        })
      }
      setErrorMessage('')
    } else {
      setErrorMessage('Model Number Required')
      setIsLoading(false)
      setShowSpinner(false)
    }
  }

  const onCancel = () => {
    if (newComponent.id) {
      if (!_.isMatch(component, newComponent)) {
        if (confirm('Are you sure you want to cancel Edit?')) {
          setNewComponent(component)
        }
      }
      setEditCallback()
    } else {
      if (!_.isMatch(component, newComponent)) {
        if (confirm('Are you sure you want to cancel Edit?')) {
          onCancelCallBack(component)
        }
      } else {
        onCancelCallBack(component)
      }
    }
  }
  const onDelete = () => {
    if (confirm('Are you sure you want to delete this system component? This cannot be undone.?')) {
      setIsDeleting(true)
      setShowSpinner(true)
      Api.SystemComponents.delete(deviceId, newComponent.id).then(() => {
        setIsDeleting(false)
        onRefreshCallBack()
        setShowSpinner(false)
      })
    }
  }

  const onChange = (updateComponent: Partial<SystemComponent>) => {
    if (newComponent) {
      const modifiedComponent : SystemComponent = { ...newComponent, ...updateComponent }
      setNewComponent({ ...modifiedComponent })
    }
  }

  const onEdit = () => {
    setEditCallback(component)
  }

  return (
    <>
      { _.isMatch(component, editableComponent)
        ? <EditableComponent
            errorMessage={errorMessage}
            loading={loading}
            isDeleting={isDeleting}
            content={newComponent}
            onChangeCallBack={onChange}
            onCancelCallBack={onCancel}
            onSaveCallBack={onSave}
            onDeleteCallBack={onDelete}
            showSpinner={showSpinner}
          />
        : <DisplayComponent disabled={disabled} content={newComponent} onEditCallBack={onEdit} showSpinner={showSpinner} />
      }
    </>
  )
}

export default Component
